import { IonContent, IonPage } from '@ionic/react';
import { useIntl } from 'react-intl';
import DesktopHeader from 'src/components/reusable-components/desktop-header/DesktopHeader';
import { ProfileMessages } from 'src/intl/ProfileMessages';
import { StoneAgeUsersTableCard } from '../../components/users/StoneAgeUsersTableCard';
import { useToast } from 'src/components/reusable-components/useToast';
import { englishOnlyIntl, useGA4 } from '../../utils/ga4';

export const StoneAgeUsersPage: React.FC = () => {
  document.title = englishOnlyIntl.formatMessage(ProfileMessages.stoneAgeUsersLabel);
  useGA4();

  const { formatMessage } = useIntl();
  const [present] = useToast();

  const setToast = (success: boolean, message: string) => {
    present(
      {
        message: message,
      },
      success ? 'success' : 'danger',
    );
  };

  return (
    <IonPage>
      <DesktopHeader title={formatMessage(ProfileMessages.stoneAgeUsersLabel)} />
      <IonContent>
        <StoneAgeUsersTableCard setToast={setToast} />
      </IonContent>
    </IonPage>
  );
};
